import React from "react"
import LazyImage from "../../components/LazyImage"
import AppLink from "../../components/AppLink"
import ArrowRight from "../../components/icons/ArrowRight"
import "./index.scss"

export const OneCase = ({ header, desc, link, image, text }) => {
    return (
        <>
            <div className="one-case" >
                <h4 className="t-s3">{header}</h4>
                <LazyImage src={image} alt="case" />
                {desc && <p className="t-b4 case-desc">{desc}</p>}
                <AppLink className="one-case-link hov-get-in-touch-white" to={link}>
                    LEARN MORE <ArrowRight width={26} />
                </AppLink>
            </div>
            <div className="one-case-desktop">
                <div className="one-case-desktop-text">
                    <div>
                        <h4 className="t-h3">{header}</h4>
                        {text.map((el, i) => (
                            <div key={i}>
                                <p className="t-b3">
                                    {el}
                                </p>
                                <br />
                            </div>
                        ))}
                    </div>
                    <AppLink className="one-case-link hov-get-in-touch-white" to={link}>
                        LEARN MORE <ArrowRight width={26} />
                    </AppLink>
                </div>
                <div className="one-case-desktop-image">
                    {desc && <p className="t-b3 case-desc">{desc}</p>}
                    <LazyImage src={image} alt="case" />
                </div>
            </div>
        </>
    )
}
